export default __webpack_public_path__ + "static/media/logout.b3237143.svg";